import {Component, OnDestroy, OnInit} from "@angular/core";
import {SubscriptionService} from "../../../subscription/subscription.service";
import {ActivatedRoute, Router} from "@angular/router";
import {BuyService} from "../../../buy/buy.service";
import {Model} from "../../../app.model";
import {HttpClient} from "@angular/common/http";
import {CompanyService} from "../../../company/company.service";
import {CustomerService} from "../../../customer/customer.service";
import {WorkflowCspService} from "../workflow-csp.service";
import {WorkflowCspChangeSlaComponent} from "../workflow-csp-change-sla.component";

@Component({
    selector: 'app-workflow-csp-one-downgrade-sla',
    templateUrl: './workflow-csp-one-downgrade-sla.component.html',
    standalone: false
})
export class WorkflowCspOneDowngradeSlaComponent extends WorkflowCspChangeSlaComponent implements OnInit, OnDestroy {
  constructor(protected route: ActivatedRoute,
              protected router: Router,
              protected subscriptionService: SubscriptionService,
              protected buyService: BuyService,
              protected m: Model,
              protected http: HttpClient,
              protected workflowCspService: WorkflowCspService,
              protected customerService: CustomerService,
              protected companyService: CompanyService) {
    super(route, router, subscriptionService, buyService, m, http, workflowCspService, customerService, companyService);
  }

  async ngOnInit() {
    super.ngOnInit();
    await this.initWorkflow('downgrade-sla');
    this.checkOnInitPaymentStep(['address']);
    this.initialized = true;
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }

  protected checkSelectedProduct(ifStatement: boolean) {
    return this.model.subscriptionSla.index === this.model.selectedSla.index
      || this.model.subscriptionSla.index < this.model.selectedSla.index;
  }

  onDowngradeInfo(e: any) {
    this.navigate(['address']);
  }

  public onDowngradeInfoBack() {
    // Switch to workflow change cu
    this.router.navigate(['/do', 'change-sla', this.applianceId]);
  }

  public onInvoiceAddressBack() {
    this.navigate(['info']);
  }

  public onPaymentMethodBack() {
    this.navigate(['address']);
  }

  public onBuy() {
    this.buyService.confirmUpgrade().subscribe(
      (saleOrder: any) => {
        this.navigate(['complete'])
      }
    );
  }
}
